export default __webpack_public_path__ + "static/media/Waving_Hand.5fd5e069.png";